import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContextService } from 'src/app/core/service/api/context.service';
import { IssuesService } from 'src/app/core/service/api/issues.service';
import { StakeholdersService } from 'src/app/core/service/api/stakeholders.service';
import { NewEntityModal } from 'src/app/core/util/abstract/new-entity-modal';
import { showFeedback, showFeedbackSaved } from 'src/app/core/util/notification';
import { Globals } from 'src/app/globals';
import { NewEntityData } from 'src/app/shared/directive/new-entity.directive';

@Component({
  selector: 'app-context-new',
  templateUrl: './context-new.component.html',
  styleUrls: ['./context-new.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContextNewComponent extends NewEntityModal {
  types: any[] = [];
  isProcessing: boolean = false;
  stakeholders: any = [];
  issues: any = [];
  declare public entity: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: NewEntityData, public dialogRef: MatDialogRef<ContextNewComponent>, public globals: Globals, private _contextService: ContextService, private _issuesService: IssuesService, private _stakeholdersService: StakeholdersService){
    super(data, dialogRef, globals)

    this._contextService.getContextTypes().subscribe((res)=>{
      this.types = res;
    })
    this._issuesService.getUnfilteredIssuesRelation().subscribe((res)=>{
      this.issues = res;
    })
    this._stakeholdersService.getStakeholdersRelations().subscribe((res) => {
      this.stakeholders = res;
    })
  }
  
  protected initializeEntity(): void {
    this.entity = {
      text: "",
      description: "",
      types: [],
      stakeholders: [],
      issues: []
    };
  }
  
  public submit() {
    this.isProcessing = true;
    this._contextService.createContext(this.entity).subscribe((res)=>{
      this.isProcessing = false;
      const types = this.entity.types.map((item)=> item.name);
      this.dialogRef.close();
      setTimeout(() => {
        this._contextService.setContextTypeUpdated({flag: true, type: types});
        this._contextService.setContextGraphUpdated(true);
      }, 350);
      showFeedbackSaved();
    })
  }

  onSelectTheme(event){
    this.entity.types = event.value;
  }
}
